import { useClose } from "@headlessui/react"
import { useCombobox } from "downshift"
import { useEffect } from "react"
import { PopoverTextInput } from "shared-web/components/base/overlay/Popover"
import { PopoverComboboxItem } from "shared-web/components/composite/popover"

import {
  PopoverList,
  PopoverListEmpty,
  PopoverListItem,
} from "components/composite/popover"

import { PopoverMenuComboboxProps } from "./types"

function PopoverMenuCombobox({
  items,
  onSelect,
  onChangeQuery,
}: PopoverMenuComboboxProps) {
  const close = useClose()

  useEffect(() => {
    return () => {
      onChangeQuery("")
    }
  }, [onChangeQuery])

  const { getMenuProps, highlightedIndex, getItemProps, getInputProps } =
    useCombobox<PopoverComboboxItem>({
      defaultInputValue: "",
      defaultHighlightedIndex: 0,
      onInputValueChange({ inputValue }) {
        onChangeQuery(inputValue ?? "")
      },
      items,
      selectedItem: null,
      onSelectedItemChange({ selectedItem }) {
        onSelect(selectedItem)
        close()
      },
      itemToString: (item) => item?.label ?? "",
      itemToKey: (item) => item?.key ?? "",
      stateReducer: (_, { type, changes }) => {
        const defaultChanges = {
          ...changes,
          isOpen: true,
        }
        switch (type) {
          case useCombobox.stateChangeTypes.InputKeyDownEscape:
          case useCombobox.stateChangeTypes.InputKeyDownEnter:
          case useCombobox.stateChangeTypes.ItemClick:
          case useCombobox.stateChangeTypes.InputBlur:
            return {
              ...defaultChanges,
              inputValue: "",
            }
          default:
            return defaultChanges
        }
      },
      isOpen: true,
    })

  return (
    <>
      <PopoverTextInput autoFocus {...getInputProps()} />
      <PopoverList {...getMenuProps()}>
        {items.length === 0 && <PopoverListEmpty />}
        {items.map((item, index) => (
          <PopoverListItem
            key={item.key}
            isHighlighted={index === highlightedIndex}
            {...getItemProps({ item, index })}
          >
            {item.content ?? (
              <span className="min-w-0 truncate">{item.label}</span>
            )}
          </PopoverListItem>
        ))}
      </PopoverList>
    </>
  )
}

export default PopoverMenuCombobox
